import { Components, Theme } from '@mui/material'

const MuiDialog: Components<Theme>['MuiDialog'] = {
  styleOverrides: {
    root: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    paper: ({ theme }) => ({
      [theme.breakpoints.up('sm')]: {
        padding: '2rem',
      },
      [theme.breakpoints.up('md')]: {
        maxWidth: '540px',
        minHeight: '450px',
        padding: '3rem',
      },
      borderRadius: 0,
    }),
  },
}

const MuiDialogActions: Components<Theme>['MuiDialogActions'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      // for small screens, line action buttons up in a column with proper spacing
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        '> :not(:first-child)': {
          // need selector for specificity priority rules
          marginLeft: 0,
        },
      },
    }),
  },
}

const MuiDialogContent: Components<Theme>['MuiDialogContent'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      // set styles for sm breakpoints and down
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      },
    }),
  },
}

export { MuiDialog, MuiDialogActions, MuiDialogContent }
